import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class FundDetailsService {
  fundDetails$ = new BehaviorSubject(null)
  fundFamilyDetails$ = new BehaviorSubject(null)

  loadData = this.fundDetails$.asObservable()
  loadFamilyData = this.fundFamilyDetails$.asObservable()

  constructor(private readonly http: HttpClient) {}

  updateFundDetails(details) {
    this.fundDetails$.next(details)
  }

  updateFundFamilyDetails(details) {
    this.fundFamilyDetails$.next(details)
  }
}
